var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#faaa3c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1542.767,56h2V54h-2v2m1-16a10,10,0,1,0,10,10,10,10,0,0,0-10-10m0,18a8,8,0,1,1,8-8,8.012,8.012,0,0,1-8,8m0-14a4,4,0,0,0-4,4h2a2,2,0,0,1,4,0c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5A4,4,0,0,0,1543.767,44Z",
    transform: "translate(-1533.767 -40)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSac);
export default __webpack_public_path__ + "static/media/icon_sac.993d0c0ea5074046fd3a847b79f89567.svg";
export { ForwardRef as ReactComponent };